import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import CampusPage from "@/pages/CampusPage";
import AdminPage from "@/pages/AdminPage";
import CoursePage from "@/pages/CoursePage";
import ProteccionCivilPage from "@/pages/ProteccionCivilPage";
import GestionPage from "@/pages/GestionPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/campus" element={<CampusPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/campus/curso/:courseId" element={<CoursePage />} />
            <Route path="/proteccion-civil" element={<ProteccionCivilPage />} />
            <Route path="/gestion" element={<GestionPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
